import types from "../actions/actionTypes";
function actionTypeEndsInSuccess(type) {
	return type.substring(type.length - 8) === `_SUCCESS`;
}
export default function loaderReducer(state = 0, action) {
	if (action.type === types.START_ASYNC_CALL) {
		return ++state;
	} else if (action.type === types.ERROR_ASYNC_CALL || actionTypeEndsInSuccess(action.type)) {
		return state > 0 ? --state : 0;
	}
	return state;
}
